var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a2p-callout",class:_vm.type},[_c('div',{staticClass:"a2p-callout-icon"},[(_vm.type === 'warn')?_c('span',[_vm._v("⚠")]):(_vm.type === 'danger')?_c('span',[_vm._v("!")]):(_vm.type === 'success')?_c('span',[_vm._v("✓")]):_c('span',[_vm._v("i")])]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }